.menuPopoverContent {
  animation-duration: 300ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  animation-direction: alternate;
  will-change: transform, opacity;
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}

.menuPopoverContent[data-state='open'] {
  animation-name: slideDownAndFade;
}

@keyframes slideDownAndFade {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
